import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useWindowSize } from "react-use";
import { useScreenWidth } from "../hooks/useScreenWidth.js";
import { ModalDialog } from "./Modal.js";
export const ModalWithSidePanelDialog = ({ id, dialogProps, alwaysVisible = false, notInStack = false, fixedHeight = false, handleClose, children, }) => {
    const { isMinDesktop } = useScreenWidth();
    return (_jsx(ModalDialog, { id: id, maxWidth: isMinDesktop ? false : undefined, dialogProps: {
            ...dialogProps,
            PaperProps: {
                ...dialogProps?.PaperProps,
                sx: {
                    ...dialogProps?.PaperProps?.sx,
                    width: isMinDesktop && !dialogProps?.fullScreen
                        ? "fit-content"
                        : undefined,
                },
            },
        }, alwaysVisible: alwaysVisible, notInStack: notInStack, fixedHeight: fixedHeight, handleClose: handleClose, children: children }));
};
const DIALOG_WIDTHS = {
    xs: 442,
    sm: 598,
    md: 982,
    lg: 1198,
    xl: 1534,
};
export const ModalWithSidePanelSections = ({ maxWidth = "sm", maxWidthWithSideContent = "xl", sideContent, fullScreen, children, }) => {
    const { width: windowWidth } = useWindowSize();
    const { isMinDesktop } = useScreenWidth();
    const canShowSidePanel = isMinDesktop;
    if (!canShowSidePanel) {
        return (_jsxs(Box, { display: "flex", flexDirection: "column", height: "100%", children: [children, sideContent] }));
    }
    return (_jsxs(Box, { display: "flex", flexWrap: "nowrap", flexDirection: "row", flex: 1, height: "100%", width: fullScreen
            ? "100%"
            : sideContent
                ? `min(${DIALOG_WIDTHS[maxWidthWithSideContent]}px, calc(${windowWidth}px - 66px))`
                : `min(${DIALOG_WIDTHS[maxWidth]}px, calc(${windowWidth}px - 66px))`, sx: {
            transition: fullScreen
                ? "none"
                : "width 0.3s ease-out, height 0.3s ease-out",
            overflowY: "auto",
            overflowX: "hidden",
        }, children: [_jsx(Box, { display: "flex", flexDirection: "column", flex: 0, minWidth: `min(${DIALOG_WIDTHS[maxWidth]}px, 100%)`, sx: { overflowY: "auto" }, children: children }), sideContent && (_jsx(Box, { display: "flex", flexDirection: "column", flex: fullScreen ? 1 : 0, minWidth: `calc(min(${DIALOG_WIDTHS[maxWidthWithSideContent]}px, calc(${windowWidth}px - 66px)) - ${DIALOG_WIDTHS[maxWidth]}px)`, children: sideContent }))] }));
};
export const ModalWithSidePanelBaseContent = ({ children, maxWidth = "sm", }) => {
    const { width: windowWidth } = useWindowSize();
    const { isMinDesktop } = useScreenWidth();
    return (_jsx(Box, { display: "flex", flexWrap: "nowrap", flexDirection: "row", flex: 1, height: "100%", width: isMinDesktop
            ? `min(${DIALOG_WIDTHS[maxWidth]}px, calc(${windowWidth}px - 66px))`
            : undefined, children: children }));
};
//# sourceMappingURL=ModalWithSidePanel.js.map